module.exports = __webpack_public_path__ + "img/arge24-logo.0cc2463d.svg";